import { createFileRoute } from '@tanstack/react-router';
import AttendanceTable from '@/modules/attendance/attendance-table';

export const Route = createFileRoute('/(dashboard)/_dashboard/attendance/')({
  component: AttendanceTable,
});
